import React, {Component} from 'react';


class PlayRomVideo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: props.value,
            src : props.url,
        }
    }
    componentDidMount() {
        if(this.refs.video && this.state.src){
            this.refs.video.currentTime = 0
            this.refs.video.src = this.state.src;
            let pauseTime = 590;
            pauseTime = pauseTime * (this.state.value/5);
            this.refs.video.play();
            setTimeout(() => {
                this.refs.video && this.refs.video.pause();
            }, pauseTime);
        }
    }
    componentWillUnmount() {
    
    }

    render() {
        const {
            onClose
          } = this.props
        return (
            <div className="overlay-msg" >
                
                <div className="overlay-box">
                    <div className="row">
                        <div className="col-sm-2">
                            <span style={{fontSize: '48px', color: '#079EDA'}}>{this.state.value}<sup>o</sup></span>
                        </div>
                        <div className="col-sm-7">
                        <video ref="video" style={{width: '400px', height: '400px'}} src='' type="video/mp4" />
                        </div>
                        <div className="col-sm-3">
                        <button style={{width: '50px', height: '50px', borderRadius: '50%', background: '#fff'}} onClick={e => {
                            this.refs.video && this.refs.video.pause();
                            onClose(e);
                            }}>X
                        </button>
                        </div>
                    </div>                    
                </div>
            </div>
        );
    }
}

export default PlayRomVideo